import _ from 'lodash';

import Item from '../Item';
import updateItem from '../../state/tac/tacReducer/updateItem';
import updateDependentItems from '../../state/tac/tacReducer/updateDependentItems';
import addItem from '../../state/tac/tacReducer/addItem';
import removeItem from '../../state/tac/tacReducer/removeItem';

export default class Doors extends Item {
  /**
   * Gets a new version of the TAC as it looks after the doors have been changed
   * @param {*} door
   * @param {*} parentItem
   * @returns {Object}
   */
  getPostDoorUpdateTac = (door, parentItem) => {
    if (!parentItem.itemid) {
      // Existing, un-docked
      return { ...removeItem(this.app.itemContainer.tac, door) };
    } else if (!door.itemid) {
      // New, docked
      return { ...addItem(this.app.itemContainer.tac, door, parentItem) };
    } else {
      // Existing, docked
      return { ...updateItem(this.app.itemContainer.tac, door, parentItem) };
    }
  };

  /**
   * Gets a new version of the TAC as it looks after the (simulated) update
   * @param {*} door
   * @param {*} parentItem
   * @returns {Object | undefined}
   */

  getSimulatedUpdateTac = (door, parentItem) => {
    const tacWithDoorsUpdated = this.getPostDoorUpdateTac(door, parentItem);

    if (tacWithDoorsUpdated && !_.isEmpty(tacWithDoorsUpdated)) {
      const tacWithDoorDependentsUpdated = {
        ...updateDependentItems(tacWithDoorsUpdated, { triggerItem: door }),
      };

      if (
        tacWithDoorDependentsUpdated &&
        !_.isEmpty(tacWithDoorDependentsUpdated)
      ) {
        return tacWithDoorDependentsUpdated;
      }
    }
  };

  /**
   * Simulates the update that would happen if a set of doors were to be dropped
   * at a given position during a dragging event
   * @param {*} newItem The doors with their new position
   * @param {*} parentItem The new parent at this position
   * @returns {undefined}
   */
  updateDependentItemsDragging = (newItem, parentItem) => {
    if (!newItem.itemid && !parentItem.itemid) {
      // New, un-docked
      return;
    }

    const updatedTac = this.getSimulatedUpdateTac(newItem, parentItem);

    if (updatedTac) {
      this.app.itemContainer.update({
        room: this.app.room.model,
        options: this.app.itemContainerOptions,
        ratio: this.app.room.ratio,
        tac: updatedTac,
        updateOrigo: false,
      });
    }
  };
}
